import Servizi from './Servizi';
export default Servizi;
